import { Box } from '@wishket/design-system';
import { twJoin } from 'tailwind-merge';

import GrassTooltip from './GrassTooltip';

import { GrassColorLevel, GrassTileProps } from '@/shared/types';

const GRASS_COLORS: Record<GrassColorLevel | 'empty', string> = {
  empty: 'bg-w-bluegray-10',
  0: 'bg-w-bluegray-50',
  1: 'bg-[#9BE9A8]',
  2: 'bg-[#40C463]',
  3: 'bg-[#30A14E]',
  4: 'bg-[#216E39]',
};

const GrassTile = ({ date, score, colorLevel }: GrassTileProps) => {
  return (
    <Box
      key={date}
      className={twJoin('flex size-2.5 rounded-sm', GRASS_COLORS[colorLevel])}
      data-testid={`grass-${date}`}
    >
      <GrassTooltip date={date} score={score} />
    </Box>
  );
};

const EmptyGrassTile = ({ key }: { key: string }) => {
  return (
    <Box
      key={key}
      className={twJoin('size-2.5 rounded-sm', GRASS_COLORS['empty'])}
    />
  );
};

export { GrassTile, EmptyGrassTile };
